import { apis, apiHolder as api } from 'api';
const performance = api.api.requireLogicalApi(apis.performanceImpl);
import { ERROR_REQUEST_CANCLE } from '@web-mail/common/constant';
import { getIn18Text } from 'api';
export { ERROR_REQUEST_CANCLE } from '@web-mail/common/constant';
const debounceRequestTimeout = 40000;
export const debounceMailListRequest = (fn, globalConfig) => {
    let userPromise = null;
    let promiseAbort = null;
    let startTime = 0;
    let requestTimer = null;
    const getCallback = (callback, config) => (...params) => {
        if (userPromise && promiseAbort) {
            promiseAbort(ERROR_REQUEST_CANCLE);
        }
        const res = callback(...params);
        if (requestTimer) {
            clearTimeout(requestTimer);
            requestTimer = null;
        }
        startTime = new Date().getTime();
        requestTimer = setTimeout(() => {
            try {
                const reqParams = params && params.length ? params[0] : {};
                performance.point({
                    statKey: 'mail_list_load_timeout',
                    statSubKey: config || '',
                    params: reqParams,
                    value: debounceRequestTimeout,
                    valueType: 1,
                });
            }
            catch (e) {
                console.error(e);
            }
            requestTimer = null;
            startTime = null;
        }, debounceRequestTimeout);
        if (res instanceof Promise) {
            const warpPromise = Promise.race([
                res,
                new Promise((resolve, reject) => {
                    promiseAbort = reject;
                }),
            ])
                .then(res => {
                try {
                    const reqParams = params && params.length ? params[0] : {};
                    if (startTime) {
                        const time = new Date().getTime() - startTime;
                        performance.point({
                            statKey: 'mail_list_request_load_time',
                            statSubKey: config || '',
                            params: reqParams,
                            value: time,
                            valueType: 1,
                        });
                    }
                }
                catch (e) {
                    console.error(e);
                }
                if (requestTimer) {
                    clearTimeout(requestTimer);
                    requestTimer = null;
                }
                startTime = null;
                return res;
            })
                .catch(err => {
                if (requestTimer && err !== ERROR_REQUEST_CANCLE) {
                    clearTimeout(requestTimer);
                    requestTimer = null;
                    startTime = null;
                }
                throw err;
            });
            userPromise = res;
            return warpPromise;
        }
        throw new Error(getIn18Text('HANSHUBIXUFAN'));
    };
    if (fn) {
        return getCallback(fn, globalConfig);
    }
    return (callback, config) => getCallback(callback, config);
};
export const debounceRequest = (fn) => {
    let userPromise = null;
    let promiseAbort = null;
    const getCallback = (callback) => (...params) => {
        if (userPromise && promiseAbort) {
            promiseAbort(ERROR_REQUEST_CANCLE);
        }
        const res = callback(...params);
        if (res instanceof Promise) {
            const warpPromise = Promise.race([
                res,
                new Promise((resolve, reject) => {
                    promiseAbort = reject;
                }),
            ]);
            userPromise = res;
            return warpPromise;
        }
        throw new Error(getIn18Text('HANSHUBIXUFAN'));
    };
    if (fn) {
        return getCallback(fn);
    }
    return (callback) => getCallback(callback);
};
export const debouceRequestByRule = (fn, config) => {
    const { canAbort = () => true, retryNums = 0, retryInterval = 0 } = config !== null && config !== void 0 ? config : {};
    let taskList = [];
    const queueActiveOper = (taskId) => {
        const task = taskList.find((item) => item.id === taskId);
        const head = taskList[0];
        if (task && head) {
            task.customSuccess = true;
            if (taskId === head.id) {
                let curTask = taskList.shift();
                while (curTask) {
                    curTask.success();
                    if (taskList.length && taskList[0].customSuccess) {
                        curTask = taskList.shift();
                    }
                    else {
                        break;
                    }
                }
            }
        }
    };
    const queueFailOper = (taskId, e) => {
        let status = false;
        let posi = taskList.length;
        if (taskList.find(item => item.id === taskId)) {
            taskList.forEach((item, index) => {
                if (taskId === item.id) {
                    posi = index;
                }
                if (taskId === item.id || status) {
                    status = true;
                    item.abort(e);
                }
            });
            taskList = taskList.slice(0, posi);
        }
    };
    const retry = (callback, r, j, sum) => {
        callback()
            .then(res => {
            r(res);
        })
            .catch(e => {
            if (sum > 0) {
                setTimeout(() => {
                    retry(callback, r, j, sum - 1);
                }, retryInterval);
            }
            else {
                j(e);
            }
        });
    };
    const getCallback = (callback, _canAbort) => (...params) => {
        const logicCanAbort = _canAbort || canAbort;
        if (logicCanAbort(taskList.map(item => item.reqParams), params)) {
            if (taskList && taskList.length) {
                while (taskList.length > 0) {
                    const task = taskList.shift();
                    task.abort(ERROR_REQUEST_CANCLE);
                }
            }
        }
        const taskId = new Date().getTime();
        const helper = new Promise((r, j) => {
            taskList.push({
                success: r,
                abort: j,
                id: taskId,
                customSuccess: false,
                reqParams: params,
            });
        });
        const customPromise = new Promise((r, j) => {
            retry(() => callback(...params), r, j, retryNums);
        });
        if (customPromise instanceof Promise) {
            customPromise.then(res => {
                queueActiveOper(taskId);
                return res;
            });
            const warpPromise = new Promise((r, j) => {
                Promise.all([helper, customPromise])
                    .then(res => r(res[1]))
                    .catch(e => {
                    j(e);
                    queueFailOper(taskId, e);
                });
            });
            return warpPromise;
        }
        throw new Error(getIn18Text('HANSHUBIXUFAN'));
    };
    if (fn) {
        return getCallback(fn);
    }
    const warpFn = (callback, userCanAbort) => getCallback(callback, userCanAbort);
    return warpFn;
};
export default debounceRequest;
